// CUSTOM: wallet points
function CheckWalletPoints() {
    // Click on checkbox for wallet points
    $('#chkUsePoints').click(function () {
        if ($(this).prop('checked')) {
            var strAction = 'add';
        } else {
            var strAction = 'remove';
        }
        // Add/remove wallet points to/from cart
        $.post(strAjaxPath + 'cart/wallet-points.php', 'strAction=' + strAction, function (arrData) {
            // Reload page
            document.location.reload();
        });
    });
}

window.CheckWalletPoints = CheckWalletPoints;